export enum MembersRoutes {
  root = 'members',
  add = 'add',
  id = ':id',
  profile = 'profile',
  permissions = 'permissions',
  inboxes = 'inboxes',
  active = 'active',
  pending = 'pending',
  requests = 'requests',
  salesmsgAccess = 'salesmsg-access',
  inboxAccess = 'inbox-access',
  permissionsUpdate = 'permissions-update',
}
